import React from 'react'

function FormatCurrency({ amount }) {

    const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencySign: 'accounting',
    }).format(amount).replace("$", "₵")

    return (
        <p>
            {formattedAmount}
        </p>
    )
}

export default FormatCurrency